import React from 'react';
import { Box, Typography } from '@mui/material';

const FastEntryWatermark = ({ size = 'small' }) => {
  // Define size-based styling
  const getSizeStyles = () => {
    switch (size) {
      case 'small':
        return {
          container: {
            width: '60px',
            height: '75px',
          },
          logo: {
            fontSize: '1.2rem',
          },
          text: {
            fontSize: '0.7rem',
          },
        };
      case 'large':
        return {
          container: {
            width: '200px',
            height: '250px',
          },
          logo: {
            fontSize: '2.5rem',
          },
          text: {
            fontSize: '1.2rem',
          },
        };
      case 'medium':
      default:
        return {
          container: {
            width: '100px',
            height: '125px',
          },
          logo: {
            fontSize: '1.8rem',
          },
          text: {
            fontSize: '0.9rem',
          },
        };
    }
  };

  const sizeStyles = getSizeStyles();

  return (
    <Box
      sx={{
        ...sizeStyles.container,
        bgcolor: "transparent",
        border: "1px solid #e4e7ea",
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        color: "#d2d6da",
        borderRadius: 1,
      }}
    >
      <Typography
        variant="h2"
        sx={{
          color: "inherit",
          marginBottom: 0,
          fontSize: sizeStyles.logo.fontSize,
        }}
      >
        DGI
      </Typography>
      <Typography
        variant="body2"
        sx={{
          color: "inherit",
          fontSize: sizeStyles.text.fontSize,
          textAlign: "center",
          lineHeight: 1.2
        }}
      >
        Select
        <br />
        a
        <br />
        style
      </Typography>
    </Box>
  );
};

export default FastEntryWatermark;